export default "__VITE_ASSET__f01UARcq__"